// extracted by mini-css-extract-plugin
export var avatarContainer = "_52-1";
export var largeAvatarContainer = "_52-2";
export var smallAvatarContainer = "_52-0";